module.exports = __webpack_public_path__ + "img/vertical_7_4_8023.6cdd9290.png";